import { paths } from "@/src/routes/paths";

export interface ExpertiseItem {
  number: string;
  title: string;
  tags: string[];
  description: string;
  href: string;
}

export const expertiseItems: ExpertiseItem[] = [
  {
    number: "01",
    title: "AI SaaS Product Development",
    tags: ["Frontend", "Backend", "AI / ML", "Vector DB", "Database", "DevOps"],
    description:
      "We help turn your AI vision into a product that people can actually use, love, and rely on. From product strategy and design to AI integration and development, we build scalable SaaS platforms around your business goals not just around technology. Our focus goes beyond getting your product live. We create the right foundation for growth, combining intelligent AI capabilities with seamless user experiences, reliable architecture, and the flexibility to evolve as your business grows.",
    href: paths.services.aiSaasProductDevelopment,
  },
  {
    number: "02",
    title: "AI SaaS MVP Development",
    tags: ["Frontend", "Backend", "AI / ML", "Cloud"],
    description:
      "Have an AI idea but not sure where to start? We help you turn that idea into a focused MVP that gets into users’ hands faster. We identify the features that matter most, build around your core value proposition, and create a product that helps you validate your idea with real-world feedback. The goal is simple: learn faster, reduce unnecessary investment, and build with confidence. As your idea gains traction, your MVP can evolve into a scalable AI SaaS product.",
    href: paths.services.aiSaasMvpDevelopment,
  },
  {
    number: "03",
    title: "Generative AI Development",
    tags: ["LLM", "AI / ML", "Vector DB", "Cloud"],
    description:
      "Generative AI can do much more than generate text. We help businesses use it to create smarter products, automate content-heavy workflows, understand information, and deliver more personalized user experiences. From intelligent assistants and content generation to knowledge systems and AI-powered workflows, we build solutions that fit naturally into your product and solve meaningful business problems.",
    href: paths.services.generativeAiDevelopment,
  },
  {
    number: "04",
    title: "AI Integration & Automation",
    tags: ["AI / ML", "Backend", "DevOps"],
    description:
      "You don't always need to replace your existing systems to bring AI into your business. We integrate AI with the tools, platforms, and workflows you already use, helping you eliminate repetitive work and make everyday processes smarter. Whether it's automating operations, processing documents, handling customer interactions, or connecting disconnected systems, we help AI work quietly in the background so your team can focus on higher-value work.",
    href: paths.services.aiIntegrationAutomation,
  },
  {
    number: "05",
    title: "Product Engineering & Scaling",
    tags: ["Backend", "Database", "Cloud", "DevOps"],
    description:
      "Building a product is only the beginning. As users grow and your business evolves, your technology needs to keep up. We help strengthen your product with reliable engineering, modern architecture, and scalable systems designed to handle what's next. Whether you're improving an existing platform or preparing for rapid growth, we focus on performance, reliability, security, and maintainability so your product doesn't become a limitation to your ambition.",
    href: paths.services.saasProductEngineering,
  },
  {
    number: "06",
    title: "AI Agent Development",
    tags: ["AI / ML", "LLM", "Backend"],
    description:
      "AI agents are changing the way businesses work. Instead of simply responding to a question, an AI agent can understand context, use tools, make decisions, and take action on your behalf. We build AI agents around real business workflows from customer support and research to operations and internal processes—helping your teams move from manual execution to intelligent automation.",
    href: paths.services.aiAgentDevelopment,
  },
];
